import './style.scss'
import { useState } from "react"
import { AppCenterPopup } from "src/component/CenterPopup"
import { FlexRow, Button, CustomContainer, ScreenTitle, Icon, AppSpan, AppText, Circle } from "src/style"
import {IoMdCheckmark} from 'react-icons/io'
import {savedCards} from 'src/utils/mock-data'
import { cardTypes } from "src/utils/logo"
import { CenterPopupHeader, LogoCreation } from "src/component"
import { HiOutlinePlusSm } from "react-icons/hi"


export const SavedCards: React.FC<any> = ({handleSelectedCard, close}) => {
    const [selectedCard, setSelectedCard] = useState<any>({})

    function handleSelection (item: any) {
        setSelectedCard(item)
        handleSelectedCard(item)
        close()
    }

    return (
        <AppCenterPopup height='54.8' zIndex='6' close={close}>
            <CenterPopupHeader close={close} />
            <CustomContainer height="43.8" className='popup-content-container'>
                <CustomContainer topMargin="1.5">
                    <ScreenTitle textSize="2.2" fontWeight="700" align="center">Saved Cards</ScreenTitle>
                    <CustomContainer  topMargin='2'>
                        {
                            savedCards?.map((item, index) => {
                                return (
                                    <FlexRow
                                        minHeight="10" radius="0.8" justifyContent="space-between"
                                        borderColor={selectedCard.cardType === item.cardType ? '#0D968F' : "#EAECF0"}
                                        bgColor={selectedCard.cardType === item.cardType ? '#E7F6F5' : "#ffffff"}
                                        alignItems="flex-start" padding="1.5" key={index} bottomMargin='1.5'
                                        topPadding="1.2" bottomPadding="1" gap='1.5'
                                        onClick={() => handleSelection(item)}
                                    >
                                        <FlexRow width="auto" sizeUnit="" alignItems="flex-start">
                                            <CustomContainer width='4.6' height='3.2' borderColor="#F2F4F7" radius="0.6" rightMargin="1">
                                                { cardTypes[item.cardType] ?
                                                    <Icon src={cardTypes[item.cardType]} minWidth='100' /> 
                                                    : <LogoCreation name={item.cardType} textSize='1.8' />
                                                }
                                            </CustomContainer>
                                            <CustomContainer width="auto" sizeUnit="">
                                                <AppSpan fontWeight="600" color={selectedCard.cardType === item.cardType ? '#085B56' : "#344054"}>{item.title}</AppSpan>
                                                <AppText color={selectedCard.cardType === item.cardType ? "#0D968F" : "#667085"}>Expiry {item.expiryDate}</AppText>
                                                <FlexRow width="auto" sizeUnit="" topMargin="0.5">
                                                    <AppSpan 
                                                        fontWeight="600" color={selectedCard.cardType === item.cardType ? '#0EA59D' : "#667085"} 
                                                        rightMargin="2" cursor="pointer"
                                                    >
                                                        Set as default
                                                    </AppSpan>
                                                    <AppSpan fontWeight="600" color="#0A756F" cursor="pointer">Edit</AppSpan>
                                                </FlexRow>
                                            </CustomContainer>
                                        </FlexRow>
                                        <Circle 
                                            size="1.6" 
                                            borderColor={selectedCard.cardType === item.cardType ? "#0D968F" : "#D0D5DD"}
                                            bgColor={selectedCard.cardType === item.cardType ? "#0D968F" : "#ffffff"}
                                        >
                                            { selectedCard.cardType === item.cardType &&
                                                <IoMdCheckmark style={{color: '#ffffff'}} />
                                            }
                                        </Circle>
                                    </FlexRow>
                                )
                            })
                        }
                        <FlexRow className="acct-add-new-card">
                            <HiOutlinePlusSm style={{color: '#667085', fontSize: '2.2rem', marginRight: '1rem'}}/>
                            <AppText fontWeight="600" color="#667085" cursor="pointer">Add new payment method</AppText>
                        </FlexRow>
                    </CustomContainer>
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopup>
    )
}
